import { useQuery } from '@tanstack/react-query';
import { G_CROP_BY_ID_QUERY_KEY } from 'constants/queryKeys';
import { GSeedSpecies } from 'interfaces/IGlobalCatalogue';
import { GlobalCatalogueService } from 'services/GlobalCatalogueServices';

/**
 * Fetch a single GSeedSpecies by globalId, for crops not yet in the loaded
 * crop catalogue pages. Seed species are static reference data, so the
 * result is cached for the session.
 */
export const useFetchGSeedSpeciesById = (id: string | null, enabled = true) =>
  useQuery<GSeedSpecies>({
    queryKey: [G_CROP_BY_ID_QUERY_KEY, id],
    queryFn: () => GlobalCatalogueService.FetchGSeedSpeciesById(id!),
    enabled: enabled && !!id,
    staleTime: Infinity,
    // The Production Add button waits on this, so fail fast on a missing crop
    retry: 1,
  });
